import { Building2, HardHat, Hammer, Palette } from "lucide-react";
import { IMG } from "@/lib/content";
import { goToEstimate } from "@/lib/scroll";
import { Eyebrow, Reveal } from "./Reveal";

const AUDIENCE = [
  { icon: HardHat, title: "Contractors", text: "Dependable scheduling that keeps your jobs moving." },
  { icon: Hammer, title: "Remodelers", text: "Tear-out ready tops with precise laser templating." },
  { icon: Building2, title: "Builders", text: "Consistent quality across single homes and multi-unit builds." },
  { icon: Palette, title: "Designers", text: "Slab guidance and finishes that honor your vision." },
];

export const Trade = () => (
  <section id="trade" data-testid="trade-section" className="bg-[#0B0F17] py-24 lg:py-36">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="grid gap-4 lg:grid-cols-12">
        <Reveal className="relative overflow-hidden lg:col-span-5">
          <div className="relative flex h-full min-h-[420px] flex-col justify-end p-8">
            <img src={IMG.bar} alt="Custom bar and island countertops for a basement build" loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F17] via-[#0B0F17]/50 to-transparent" />
            <div className="relative">
              <Eyebrow>For the trade</Eyebrow>
              <h2 className="mt-4 font-display text-4xl leading-[1.05] text-[#F5F0E6] sm:text-5xl">A fabrication partner <span className="italic text-[#CDA85B]">you can schedule around.</span></h2>
              <button onClick={() => goToEstimate({ customer_type: "Contractor" })} data-testid="trade-cta-btn" className="ks-btn-gold mt-7">Send Us Your Plans</button>
            </div>
          </div>
        </Reveal>
        <div className="grid gap-4 sm:grid-cols-2 lg:col-span-7">
        {AUDIENCE.map(({ icon: Icon, title, text }, i) => (
          <Reveal key={title} delay={i * 0.08} className="h-full">
            <div data-testid={`trade-card-${title.toLowerCase()}`} className="group flex h-full min-h-[200px] flex-col justify-between gap-8 border border-white/[0.07] bg-[#10151F] p-7 transition-colors duration-500 hover:border-[#CDA85B]/40">
              <Icon className="h-7 w-7 text-[#CDA85B] transition-transform duration-500 group-hover:-translate-y-1" strokeWidth={1.3} />
              <div>
                <h3 className="font-display text-3xl text-[#F5F0E6]">{title}</h3>
                <p className="mt-2 text-sm text-[#C4C1B9]">{text}</p>
              </div>
            </div>
          </Reveal>
        ))}
        </div>
      </div>
      <Reveal delay={0.2}>
        <p className="mt-8 text-sm text-[#B8B4AA]">In-house fabrication · Laser templating · Projects of all sizes · Typical installation 5–10 business days after deposit</p>
      </Reveal>
    </div>
  </section>
);
